import React from 'react';
import ApiContext from './context';
import schema from './schema';
import router from './router';
import useUser from '../auth/hooks';

const ApiProvider = ({ children }) => {
  const { user } = useUser();
  const currentRouter = user && user.isAdmin ? router.admin : router.cabinet;
  return (
    <ApiContext.Provider value={{ schema, router: currentRouter }}>
      {children}
    </ApiContext.Provider>
  );
};

export default ApiProvider;
